import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'DASHBOARD_UPDATE',
    smsDelete : 'DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        dashboard_count: {},
        dashboardCountLoading: false,
        dashboardCountError: false,
 

        ...store
    },

    mutations : {
        ...mutations,

        SET_DASHBOARD_COUNT(state, items) {
            state.dashboard_count = items;
        },
     
        DASHBOARD_COUNT_LOADING (state, loading) {
            state.dashboardCountLoading = loading;
        },

        DASHBOARD_COUNT_ERROR (state, hasError) {
            state.dashboardCountError = hasError;
        }
    },

    actions: {
        async fetchDashboardCount ({ commit }) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_dashboard_count, config);
                let response = result.data
                commit('SET_DASHBOARD_COUNT', response.data);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        }
    },

    getters: {}
}
